import { useGlobalAppState } from "@/utils/app-state";
import { useSession } from "next-auth/react";

export interface DangerousChalkEmployeeOpts {
  ignoreAdminMode?: boolean;
}

/**
 * Dangerously compare against the session user's email address to determine
 * if the user can use/view the query UI. This is a spicy utility and should not
 * be used very often; feature flags are much preferred.
 */
export function useDANGEROUSisChalkEmployee({
  ignoreAdminMode = false,
}: DangerousChalkEmployeeOpts = {}): boolean {
  const {
    state: { adminMode, demoMode },
  } = useGlobalAppState();

  const session = useSession();
  const isChalkEmployee =
    session.status === "authenticated" &&
    session.data?.user?.email != null &&
    session.data.user.email.endsWith("@chalk.ai");

  // Demo mode shows admin-only components regardless of the adminMode toggle; the red
  // visual treatment is suppressed separately via the `chalk-demo-mode` root class.
  return ignoreAdminMode ? isChalkEmployee : (adminMode || demoMode) && isChalkEmployee;
}
